import { Component, ElementRef, Renderer2 } from '@angular/core';
import { SafeHtml, Title } from '@angular/platform-browser';
import { AppLocaleService } from '@core/services/app-locale.service';
import { BrandingHTMLInjectorService } from './shared/services/branding-htmlinjector.service';
import { TranslateService } from '@ngx-translate/core';
import { version_string } from '../version';

@Component({
	selector: 'cass-app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'CrossAd SelfService';

	public brandingPageHeader?: SafeHtml;
	public brandingPageFooter?: SafeHtml;

	constructor(private _appLocaleService: AppLocaleService,
				private _brandingHtmlInjector: BrandingHTMLInjectorService,
				private _titleService: Title,
				private _translate: TranslateService,
				private _elRef: ElementRef,
    			private _renderer: Renderer2) {
		// set the version number into index.html so it can be accessed in Help page (which is custom html)
		const el = (this._elRef.nativeElement as HTMLElement).ownerDocument.querySelector("meta[name='application-name']");
		this._renderer.setAttribute(el, 'data-version', version_string);
		// set translated window title
		this._translate.get("APP.TITLE").subscribe(title => this._titleService.setTitle(title));
		// inject custom header and footer html
		this.injectBranding();
	}

	private async injectBranding(): Promise<void> {
		this.brandingPageHeader = await this._brandingHtmlInjector.getInjectableHTMLFromFile('./branding/html/page-header.html');
		this.brandingPageFooter = await this._brandingHtmlInjector.getInjectableHTMLFromFile('./branding/html/page-footer.html');
	}
}
